<template>
    <Layout>
        <!--==================================================-->
        <!-- Start lawyern breatcam section  -->
        <!--==================================================-->
        <div class="breatcam-section d-flex align-items-center">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breatcam-content text-center">
                            <div class="breatcam-title">
                                <h1> {{ $t('header.nav.contact') }} </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--==================================================-->
        <!-- End lawyern breatcam section -->
        <!--==================================================-->

        <!--==================================================-->
        <!-- Start lawyer service section  -->
        <!--==================================================-->
        <div class="service-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="contact-single-box" v-for="(item, index) in list" :key="index">
                            <div class="contact-left">
                                <div class="contact-title">{{ item.name }}</div>
                                <div class="contact-info">
                                    <i class="bi bi-phone-fill"></i>
                                    <span>{{ item.mobile }}</span>
                                </div>
                                <div class="contact-info">
                                    <i class="bi bi-geo-alt-fill"></i>
                                    <span>{{ item.address }}</span>
                                </div>
                            </div>
                            <div class="contact-right">
                                <div class="contact-locate">
                                    <!-- 使用序号循环展示图片 -->
                                    <div class="map-image-wrapper" @click="openTencentMap(item)">
                                        <img
                                            :src="getLocationImage(index)"
                                            :alt="item.name"
                                            class="map-image"
                                            loading="lazy"
                                            @error="handleImageError($event)"
                                        />
                                        <!-- 悬停提示 -->
                                        <div class="map-overlay">
                                            <i class="bi bi-arrows-angle-expand"></i>
                                            <span>点击查看详细位置</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--==================================================-->
        <!-- End lawyer service Section -->
        <!--==================================================-->
    </Layout>
</template>

<script>
  import Layout from '@/components/common/Layout'

  export default {
    name: 'Demo',
    components: {Layout},
    data() {
      return {
        list: []
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      // 根据索引获取对应的图片（PNG格式）
      getLocationImage(index) {
        // 图片从 1 开始编号，所以索引 + 1
        const imageNumber = index + 1

        try {
          // 动态加载PNG图片：1.png, 2.png, 3.png, 4.png, 5.png, 6.png
          return require(`@/assets/images/map/${imageNumber}.png`)
        } catch (e) {
          // 如果图片不存在，返回默认图片
          return require('@/assets/images/map/default.png')
        }
      },

      // 图片加载错误时使用默认图片
      handleImageError(event) {
        event.target.src = require('@/assets/images/map/default.png')
      },

      // 打开腾讯地图
      openTencentMap(item) {
        if (!item.latitude || !item.longitude) {
          const searchUrl = `https://apis.map.qq.com/uri/v1/geocoder?addr=${encodeURIComponent(item.address)}&referer=myapp`
          window.open(searchUrl, '_blank')
          return
        }

        const { latitude, longitude, address, name } = item
        const encodedAddress = encodeURIComponent(address || name || '')

        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

        if (isMobile) {
          const appUrl = `qqmap://map/marker?marker=coord:${latitude},${longitude};title:${encodedAddress}&referer=myapp`
          window.location.href = appUrl

          setTimeout(() => {
            const webUrl = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${latitude},${longitude};title:${encodedAddress}&referer=myapp`
            window.location.href = webUrl
          }, 3000)
        } else {
          const webUrl = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${latitude},${longitude};title:${encodedAddress}&referer=myapp`
          window.open(webUrl, '_blank')
        }
      },

      // 获取数据
      getData() {
        this.$request({
          url: 'api/pc/office-list',
          data: this.search
        }).then(res => {
          this.list = res.data.list || []
        }).catch(err => {
          console.error('获取数据失败:', err)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .breatcam-section {
        background-image: url(~@/assets/scss/page/image/contact/bg.jpg);
    }

    .contact-single-box {
        display: flex;
        align-items: flex-start;
        margin-bottom: 60px;

    .contact-left {
        width: 40%;

    .contact-title {
        color: var(--color-main);
        font-size: 24px;
        font-weight: 600;
        padding-bottom: 22px;
        border-bottom: 1px solid #E6E6E6;
        margin-bottom: 28px;
    }

    .contact-info {
        font-size: 18px;
        padding-bottom: 20px;

    i {
        margin-right: 20px;
    }
    }
    }

    .contact-right {
        flex: 1;

    .contact-locate {
        width: 100%;

    .map-image-wrapper {
        height: 357px;
        margin-left: 70px;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        background: #f5f5f5;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;

    &:hover {
         box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
         transform: scale(1.01);

    .map-overlay {
        opacity: 1;
    }
    }

    .map-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    .map-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 15px 20px;
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 14px;
        opacity: 0;
        transition: opacity 0.3s ease;

    i {
        font-size: 18px;
    }
    }
    }
    }
    }
    }

    // 响应式适配
    @media (max-width: 992px) {
        .contact-single-box {
            flex-direction: column;

        .contact-left {
            width: 100%;
            margin-bottom: 30px;
        }

        .contact-right .contact-locate .map-image-wrapper {
            margin-left: 0;
            height: 250px;
        }
    }
    }

    @media (max-width: 576px) {
        .contact-single-box {
        .contact-right .contact-locate .map-image-wrapper {
            height: 200px;
        }
    }
    }
</style>
